import * as React from 'react';
import localStoradge, {emails} from "../../../js/localStoradge";
import { connect } from 'react-redux';
import api from "../../api/api.js";
import {Share as share} from "../../actions/update";
import {setScreen} from "../../actions/activation";
import { MultiSelect } from '@progress/kendo-react-dropdowns';


class CreateEmailComponent extends React.Component {
    state = {
        mail : '',
        popup : false,
        text : '',
        subject: window.shareTexts.email.subject,
        facebook: window.shareTexts.email.facebook,
        instagram: window.shareTexts.email.instagram,
        name: window.form_name ? window.form_name : window.shareTexts.email.name,
        value : ''
        // emailsFilter: ''
    };
    itemRender = (li, itemProps) => {
        const index = itemProps.index;
        const itemChildren = <span style={{ color: "#252626", fontFamily: '"Sen", sans-serif', fontSize: '16px', fontStyle: "normal" }}>{li.props.children}</span>;

        return React.cloneElement(li, li.props, itemChildren);
    };
    getMails = () =>{
        let Usedemails =[];
        const Emails =  window.UserId ? window.sent_emails.split(',') : emails ;
        if(Emails && Emails.length){
            Emails.map((item,index)=>{
                if(item && ValidateEmail(item) && Usedemails.indexOf(item)==-1){
                    Usedemails.push(item);
                }

            })
        }
        return Usedemails;
    }
    constructor(props) {
        super(props);
    }
    handleChange = (event,data) => {
        const values = data ? event.target.value.concat([data]) : event.target.value;
        // const lastItem = values[values.length - 1];
        //
        // if (lastItem && this.isCustom(lastItem)) {
        //     values.pop();
        //     const sameItem = values.find(v => v.text === lastItem.text);
        //     if (sameItem === undefined) {
        //         this.addKey(lastItem);
        //         values.push(lastItem);
        //     }
        // }
        let mails = values.filter(item=> (ValidateEmail(item))).filter(onlyUnique);
        if(mails.length>=9){
            this.setState({
                    popup: true
                });
			setTimeout(() => {
                 this.setState({
                    popup: false
                });
            },4000);
            mails.length=8;
        }
        this.setState({
            mail: mails.join(',')
        });
    }
    checkMails(){
        const {mail} = this.state;
        const target = document.getElementById('MultiSelect');
        let values = target.value.split(/[\s\,]+/g);
        values = values.concat(mail.split(','));
        let mails = values.filter(item=> (ValidateEmail(item))).filter(onlyUnique);
        if(mails.length>=9){
             this.setState({
                    popup: true
                });
			setTimeout(()=> {
                 this.setState({
                    popup: false
                });
            },4000);
            mails.length=8;
        }
        this.setState({
            mail: mails.join(',')
        });
        target.value='';
    }

    isCustom(item) { return item.id === undefined; }
    addKey(item) { item.id = new Date().getTime(); }
    render() {
        const {mail,text,popup} = this.state;
        const {activeGloopOptions, gloop, videoVersion, options} = this.props;
        const customization_url  = (/*!window.UserId &&*/ videoVersion < 3 && !gloop.post_date) ? options.data.storyVideo : gloop.data.customization_url;
        const counter = String(activeGloopOptions ? activeGloopOptions.id : '').split('-').length;
        const number = String(activeGloopOptions ? activeGloopOptions.id : '').split('-')[1];
        const urlFinish = String('-' + number);
        const urlFinishMail = String('-' + number + '.mp4');
        var id = gloop.data.customization_url;
        var splits = id.split('_');
        var digital = (splits.length < 3) ? splits[1].split('.') : (splits[1] + "_" + splits[2]).split('.');
        var digital_id = digital[0];
        var jsonGloop = JSON.stringify(gloop);
        var emailUrl = (videoVersion <= 1 && !gloop.post_date ) ? options.data.storyVideo : customization_url;
        return (
            <div className={'sendEmailForm'}>
                <form id={'createMailForm'} name={'emailShare'}>
                    <div className={'topSectionForms'}>
                        <span className={'backSpan'} onClick={(e)=>{
                            setScreen('gloop')
                        }}></span>
                        <p>Share via email</p>
                        <button className={'sendButton'}
                                onClick = {(e)=>{
                                    e.preventDefault();
                                    localStoradge(this.state.mail);
                                    let text = mail;
                                    api.sendEmail(text, (counter < 2 ? customization_url : customization_url.replace('.mp4', urlFinishMail)), gloop.data.original_gloop, this.state.subject, this.state.name, digital_id, options.data.image, jsonGloop, this.state.facebook, this.state.instagram, (counter < 2 ? emailUrl : emailUrl.replace('.mp4', urlFinishMail))).then(function (data) {
                                        if (data.status != 'error') {
                                            share('email');
                                            setScreen('afterShare');
                                        }
                                        else {
                                            // setScreen('errorScreen');
                                            window.jQuery('#toMessage').css({border : '1px solid red'});
                                        }
                                    });
                                    window.removeGloop(gloop.ID);
                                }}
                                type={'submit'}>send</button>
                    </div>
                    <label htmlFor={'fromMessage'}>Name:</label>

                    <input id={'fromMessage'} type="text"  name={'shareFrom'} value={this.state.name} onChange={(event) => {
                        this.setState({
                            name: event.target.value
                        });
                    }}/>
                    <label htmlFor={'subjectMessage'}>Subject:</label>
                    <input id={'subjectMessage'} type="text"  name={'shareFrom'} value={this.state.subject} onChange={(event)=> {
                        this.setState({
                            subject: event.target.value
                        });
                    }}/>
                    <div className={'autocomplete-popup'}>
                        {/*{emails ? emails.map(item => <span>{item + ", "}</span>) :  ""}*/}
                    </div>
                    <div className={'toMessage-wrapper'}>
                        <label htmlFor={'toMessage'}>To:</label>
                        {popup ? <span className={"upgrade-info"} id={'upgrade-info phones'}>
                            You can share Toing with 8 emails each time
                        </span> : ''}
                        {/*<textarea name="toMessage" id={'toMessage'} onChange={(event) =>{*/}
                        {/*    this.setState({*/}
                        {/*        mail : event.target.value*/}
                        {/*    });*/}
                        {/*}}>{mail}</textarea>*/}
                        <MultiSelect
                            id={'MultiSelect'}
                            listNoDataRender ={()=>''}
                            data={this.getMails()}
                            onBlur = {(e)=>{
                               this.checkMails();
                            }}
                            onChange={this.handleChange}
                            onFocus={()=>{
                                    document.getElementById('MultiSelect').onkeypress = (e) => {
                                    if(e.keyCode == 44 || e.keyCode == 32){
                                        this.checkMails();
                                    }
                                }
                            }}
                            value={mail.split(',').filter(item => item)/*.map(item => ({text: item , id : item}))*/}
                            onFilterChange={(e)=>{
                                console.log(e);
                            }}
                            onKeyDowd = {(e)=>{
                                console.log(e);
                            }}

                            //textField="text"
                            //dataItemKey="value"
                            allowCustom={true}
                            itemRender={this.itemRender}
                        />
                    </div>
                </form>
            </div>
        )
    }
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

const mapStateToProps = (state) => {
    const gloop = state.gloops[state.activeGloop];
    let options = null;
    if(gloop && gloop.data){
        options = state.gloopsOptions[gloop.data.original_gloop[0]]
    }
    return {
        ui: state.ui,
        activeGloopOptions : options,
        gloop : gloop,
        videoVersion : state.videoVersion,
        options : options
    };
}
const CreateEmail = connect(mapStateToProps)(CreateEmailComponent)
export default CreateEmail;

function ValidateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

